import type { ILinkProps } from "@components/cms/link/Link";
import { Link } from "@components/cms/link/Link";
import type { ILink, IPagePath } from "@contentful-api/types/contentful";
import { ECCO_CLUB_SLUG } from "@lib/constants/pagePaths";
import { isMarketWithLoyalty } from "@lib/utils/loyalty";
import { forwardRef } from "react";
import { linkTypeGuard } from "../../hooks/useLink";
import { eccoClubLinkStyles, nondisplayedLink, pageNavigationLinkStyles } from "./style";

type Props = {
    isActive: boolean;
    isAddressesLink?: boolean;
    testId?: string;
} & ILinkProps;

const isEccoClubLink = (link: ILinkProps["link"]): boolean => {
    const _link = link as ILink | IPagePath;
    const completeSlug = linkTypeGuard(_link)
        ? _link.fields.internalLink.fields.completeSlug
        : _link.fields.completeSlug;
    return completeSlug?.includes(ECCO_CLUB_SLUG) || false;
};

export const PageNavLink = forwardRef<
    HTMLElement & HTMLParagraphElement & HTMLAnchorElement,
    Props
>(function PageNavLink({ isActive, isAddressesLink, link, onClick, testId }, ref) {
    const isEccoClub = isMarketWithLoyalty && isEccoClubLink(link);

    const getLinkStyles = () => {
        if (isAddressesLink) return nondisplayedLink(isActive);
        if (isEccoClub) return eccoClubLinkStyles(isActive);
        return pageNavigationLinkStyles(isActive);
    };

    return (
        <Link
            sx={getLinkStyles()}
            link={link}
            onClick={onClick}
            _active={{ color: "white", backgroundColor: "gray.800" }}
            ref={isActive ? ref : null}
            data-testid={testId}
        />
    );
});
